import { Link } from 'wouter'

export default function AddFeed() {
  return (
    <div className="container">
      <h1>Add a feed</h1>
      <p><Link href="/">Back to reader</Link></p>
      <form method="post" action="/api/my/feeds/subscribe">
        <label>Feed URI:
          <input type="text" name="uri" placeholder="https://example.com/rss.xml" />
        </label>
        <input type="submit" />
      </form>
      <br/><br/>
      <form method="post" action="/api/my/feeds/subscribe" encType="multipart/form-data">
        <label>OR File:
          <input type="file" name="file" />
        </label>
        <input type="submit" />
      </form>
    </div>
  )
}
